import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { Typography, Divider } from "@mui/material";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowBackIosIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(-90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function FrequentlyAskedPackages() {
  const [expanded, setExpanded] = React.useState("");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      <Divider>سوالات متداول</Divider>
      <Accordion
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography>
            با وجود گزینه رایگان ، دلیل وجود پکیج های اشتراکی چیست؟
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            هیچ تفاوتی از لحاظ دسترسی در اشتراک رایگان و اشتراک پولی وجود ندارند
          </Typography>
          <Typography>
            هزینه دریافت شده از طریق پکیج پولی بصورت کامل هزینه سایت ، برنامه و
            تبلیغات برنامه می شود.
          </Typography>
          <Typography>
            در حالت رایگان افراد مختلف وظیفه معرفی برنامه را رایگان انجام می
            دهند و به پاس این عمل اوملنگ نیز به کسانی که ازاین طریق وارد
            برنامه شده اند اشتراک رایگان اهدا خواهد کرد.
          </Typography>
          <Typography sx={{ backgroundColor: "#14ff27", color: "#0004ff" }}>
            هدف ما از انشتار این نسخه برنامه ارائه یک برنامه رایگان بود ، اما به
            منظور تامین هزینه های برنامه و معرفی به زبان آموزان هر دو
            روش اشتراک رایگان و پولی ایجاد شده است.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography>نحوه استفاده از کد معرف برای تخفیف بیشتر؟</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            پس از انتخاب پکیج در <span style={{ color: "red" }}>مرحله بعد</span>{" "}
            شما می توانید کد معرف را در کادر مربوطه وارد و از تخفیف آن استفاده
            کنید
            <br />
            اغلب کد های معرفی که توسط دوستانتان برای شما ایجاد شده اند{" "}
            <span style={{ color: "red" }}>بین 5 تا 50 درصد</span> تخفیف در خرید
            پکیج به شما می دهند.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
          <Typography>تفاوت کد تخفیف و کد معرف چیست؟</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            از لحاظ کاربرد هیچ تفاوتی ندارند و{" "}
            <span style={{ color: "red" }}>
              هر دو تخفیفی را برای خرید شما ایجاد میکنند
            </span>{" "}
            ، تنها تفاوتشان این است کد معرف توسط خود اعضا ایجاد میگردد ولی کد
            تخفیف توسط برنامه اوملنگ به مناسبت های گوناگون ساخته شده و منتشر می
            شوند و عمدتا تاریخ مصرف کوتاهی دارند.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <Typography>
            می توان از تخفیف کد معرف و کد تخفیف همزمان استفاده کرد؟
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            بله <span style={{ color: "red" }}>می توانید</span> همزمان از هر دو
            تخفیف استفاده کنید . هر دو تخفیف بر روی محصول انتخابی اعمال می گردد.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
          <Typography>
            امکانات جدید و تغییر قیمت پکیج ها برای کاربرانی که قبلا خرید داشته
            اند چگونه است؟
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            هر گونه امکانات جدیدی که به پکیج اضافه شود برای کاربرانی که از قبل
            خرید داشته اند تا اتمام اعتبار پکیج آنها بصورت{" "}
            <span style={{ color: "red" }}>رایگان</span> در دسترس خواهد بود.
            <br />
            قابل ذکر است که بصورت مداوم امکانات و ویژگی های جدید به برنامه اضافه
            خواهد شد و در ابتدای عرضه برنامه (نسخه Beta) حداقل قیمتها در نظر
            گرفته شده است که پس از اضافه شدن ویژگی های جدید این تغییرات بر روی
            قیمت پکیج ها اثر گذار می باشد اما این تغییرات قیمت فقط برای کاربرانی
            که پس از اضافه شدن ویژگی جدید اقدام به خرید می کنند اعمال می شود.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
